import { BaSeParagraph, BaSeTheme } from '@base/react';
import * as React from 'react';

const ExcluirGrid = ({ texts }) => (
  <div style={{ padding: '4px 0' }}>
    {texts?.map((text, index) => (
      <BaSeParagraph
        key={index}
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      >
        {text}
      </BaSeParagraph>
    ))}
  </div>
);

export default ExcluirGrid;
